import React, { useCallback, useEffect, useRef, useState } from 'react';

type Props = {
  label: string
  value: string
  disabled?: boolean
  onChange?: (value: string) => void
}

const convertToAmPm = (time: string): string => {
  const [hourStr, minute] = time.split(':');
  let hour = parseInt(hourStr, 10);
  const isPm = hour >= 12;
  const period = isPm ? 'pm' : 'am';
  hour = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour}:${minute}${period}`;
}

const convertTo24Hour = (time: string): string => {
  const period = time.slice(-2).toLowerCase();
  let [hour, minute] = time.slice(0, -2).split(':');
  let hourNum = parseInt(hour, 10);
  if (period === 'pm' && hourNum !== 12) {
    hourNum += 12;
  } else if (period === 'am' && hourNum === 12) {
    hourNum = 0;
  }
  return `${hourNum.toString().padStart(2, '0')}:${minute}`;
}

const TimeInput: React.FC<Props> = ({ label, value, onChange, disabled }) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const redrawClockIcon = useCallback(() => {
    const reTime = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/;
    if (reTime.exec(value)) {
      const minute = Number(value.substring(3, 5));
      const hour = Number(value.substring(0, 2)) % 12 + minute / 60;
      if (inputRef?.current) {
        inputRef.current.style.backgroundImage = `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40'><circle cx='20' cy='20' r='18.5' fill='none' stroke='%23222' stroke-width='3' /><path d='M20,4 20,8 M4,20 8,20 M36,20 32,20 M20,36 20,32' stroke='%23bbb' stroke-width='1' /><circle cx='20' cy='20' r='2' fill='%23222' stroke='%23222' stroke-width='2' /></svg>"), url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40'><path d='M18.5,24.5 19.5,4 20.5,4 21.5,24.5 Z' fill='%23222' style='transform:rotate(${360 * minute / 60}deg); transform-origin: 50% 50%;' /></svg>"), url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40'><path d='M18.5,24.5 19.5,8.5 20.5,8.5 21.5,24.5 Z' style='transform:rotate(${360 * hour / 12}deg); transform-origin: 50% 50%;' /></svg>")`;
      }
    }
  }, [value])
  useEffect(() => {
    redrawClockIcon()
  }, [redrawClockIcon])
  const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTime = (e.target.value);
    if (onChange) onChange(newTime)
  }

  const inputStyle: React.CSSProperties = {
    backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40'><circle cx='20' cy='20' r='18.5' fill='none' stroke='%23222' stroke-width='3' /><path d='M20,4 20,8 M4,20 8,20 M36,20 32,20 M20,36 20,32' stroke='%23bbb' stroke-width='1' /><circle cx='20' cy='20' r='2' fill='%23222' stroke='%23222' stroke-width='2' /></svg>"), url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40'><path d='M18.5,24.5 19.5,4 20.5,4 21.5,24.5 Z' fill='%23222' style='transform:rotate(120deg); transform-origin: 50% 50%;' /></svg>"), url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40'><path d='M18.5,24.5 19.5,8.5 20.5,8.5 21.5,24.5 Z' style='transform:rotate(20deg); transform-origin: 50% 50%;' /></svg>")`,
    backgroundPosition: '0.5rem 50%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '2rem 2rem',
    border: 'none',
    padding: '10px 10px 10px 3rem',
    // color: '#222',
    fontSize: '1rem',
    // transition: 'backgroundImage 0.25s',
  };

  const wrapperStyle: React.CSSProperties = {
    display: 'flex',
    padding: '5px 10px', 
    flexDirection: 'column',
    border: '1px solid rgb(218, 223, 226)',
    borderRadius: '8px',
    color: 'rgb(98, 122, 132)',
  }

  return (
    <div style={wrapperStyle}>
      <div style={{fontSize: '12px'}}>{ label }</div>
      <div style={{display: 'flex', justifyContent: 'center'}}>
          <input
            ref={inputRef}
            disabled={disabled}
            type="time"
            name="time"
            id="time"
            value={(value)}
            onChange={handleTimeChange}
            style={inputStyle}
          />
        </div>
    </div>
  );
};

export default TimeInput;
